import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M3 10.1h4.3V5.9H3zm1-3.2h2.3v2.3H4zM3 16h4.3v-4.3H3zm1-3.3h2.3V15H4zm4.7-2.6H13V5.9H8.7zm1-3.2H12v2.3H9.7zM8.7 0v4.3H13V0zM12 3.3H9.7V1H12zM8.7 16H13v-4.3H8.7zm1-3.3H12V15H9.7zM3 4.3h4.3V0H3zM4 1h2.3v2.3H4z" />
  </svg>
);
const SvgBoxesColumns = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="boxes-columns" {...props} />;
export default SvgBoxesColumns;
